export class WindowSettings {

    // defaults
    Top: number = 200;
    Left: number = 300;
    Height: number = 400;
    Width: number = 550;
    Status: boolean = true;
    Toolbar: boolean = false;
    MenuBar: boolean = false;
    Location: boolean = false;
    AddressBar: boolean = false;

    // get settings to pass to window
    public ToString() {

        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (this.Width / 2)) + dualScreenLeft;
        var top = ((height / 2) - (this.Height / 2)) + dualScreenTop;

        var status = (this.Status == true) ? "yes" : "no";
        var toolbar = (this.Toolbar == true) ? "yes" : "no";
        var menubar = (this.MenuBar == true) ? "yes" : "no";
        var location = (this.Location == true) ? "yes" : "no"
        var addressBar = (this.AddressBar == true) ? "yes" : "no";

        var settings = "height=" + this.Height;
        settings += ",width=" + this.Width;
        settings += ",top=" + top;
        settings += ",left=" + left;
        settings += ",status=" + status;
        settings += ",toolbar=" + toolbar;
        settings += ",menubar=" + menubar;
        settings += ",location=" + location;
        settings += ",addressbar=" + addressBar;

        return settings;
    }

}